// extracted by mini-css-extract-plugin
export default {"cast":"styles_cast__8Amim","person":"styles_person__U2D3E","name":"styles_name__m003N","mobile":"styles_mobile__rvrgu"};